import AdLayout from "../../app-core/AdLayout";
import DropTablesNav from "./DropTablesNav";
import LootGrid from "../LootGrid";
import * as T from "common/src/bindings/Translation2";
import {
  Provider as TftSetProvider,
  fromNum,
} from "common/src/data/TftSet.bs.js";

type Tables = { loot: any; goldValues: any; breakpoints: any; loot5: any };

const cg5Kills = [4, 6, 9, 12, 16];

export default function CrystalGambitTables({ tables }: { tables: Tables }) {
  return (
    <AdLayout>
      <TftSetProvider.make value={fromNum(150)}>
        <div className="flex flex-col bg-bg rounded w-full md:w-[928px] pb-4">
          <DropTablesNav route={"CrystalGambit"} />
          <h2 className="h2 p-4 pb-0 flex items-center gap-1">
            {T.traits("TFT15_GemForce") + " " + T.common("Rewards")}
          </h2>
          {Object.entries(tables.loot).map(([key, options]: any) => {
            return (
              <div key={key}>
                <h3 className="pt-12 px-4 pb-5 h4 leading-tight">{`${Math.max(0, tables.breakpoints[key])} Gem Power (${tables.goldValues[key]}g)`}</h3>
                <LootGrid data={options.map((v: any) => [v.odds, v.loot])} />
              </div>
            );
          })}
          <h2 className="h2 p-4 pt-32 flex items-center gap-1">
            {T.traits("TFT15_GemForce") + " 5 " + T.common("Rewards")}
          </h2>
          {Object.entries(tables.loot5).map(([key, options]: any, idx) => {
            return (
              <div key={key}>
                <h3 className="pt-12 px-4 pb-5 h4 leading-tight">{`${cg5Kills[idx]} kills`}</h3>
                <LootGrid data={options.map((v: any) => [v.odds, v.loot])} />
              </div>
            );
          })}
        </div>
      </TftSetProvider.make>
    </AdLayout>
  );
}
